import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useUtils } from "../../services/utilsProvider";
import { Icon } from "../../ui";
import FormNews from "./FormNews";

const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 0;
    svg {
      margin: 0 20px 0 10px;
    }
  }
`;
const AddNews = () => {
  const navigate = useNavigate();
  const { notify } = useUtils();

  const handleSuccess = () => {
    navigate(-1);
    notify("news has been created successfully.");
  };
  return (
    <div id="add-news">
      <Grid>
        <h2 style={{ marginTop: "0" }}>Add New News</h2>
        <div style={{ cursor: "pointer" }}>
          <span onClick={() => navigate(-1)}>Back</span>
          <Icon name="arrowLeft" onClick={() => navigate(-1)} />
        </div>
      </Grid>

      <FormNews handleSuccess={handleSuccess} />
    </div>
  );
};

export default AddNews;
